var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 12.16C17.9401 12.15 17.8701 12.15 17.8101 12.16C16.4301 12.11 15.3301 10.98 15.3301 9.58C15.3301 8.15 16.4801 7 17.9101 7C19.3401 7 20.4901 8.16 20.4901 9.58C20.4801 10.98 19.3801 12.11 18.0001 12.16Z",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9702 19.4399C18.3402 19.6699 19.8502 19.4299 20.9102 18.7199C22.3202 17.7799 22.3202 16.2399 20.9102 15.2999C19.8402 14.5899 18.3102 14.3499 16.9402 14.5899",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96998 12.16C6.02998 12.15 6.09998 12.15 6.15998 12.16C7.53998 12.11 8.63998 10.98 8.63998 9.58C8.63998 8.15 7.48998 7 6.05998 7C4.62998 7 3.47998 8.16 3.47998 9.58C3.48998 10.98 4.58998 12.11 5.96998 12.16Z",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 19.4399C5.62994 19.6699 4.11994 19.4299 3.05994 18.7199C1.64994 17.7799 1.64994 16.2399 3.05994 15.2999C4.12994 14.5899 5.65994 14.3499 7.02994 14.5899",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 19.63C11.9401 19.62 11.8701 19.62 11.8101 19.63C10.4301 19.58 9.33008 18.45 9.33008 17.05C9.33008 15.62 10.4801 14.47 11.9101 14.47C13.3401 14.47 14.4901 15.63 14.4901 17.05C14.4801 18.45 13.3801 19.59 12.0001 19.63Z",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08997 22.7799C7.67997 23.7199 7.67997 25.2599 9.08997 26.1999C10.69 27.2699 13.31 27.2699 14.91 26.1999C16.32 25.2599 16.32 23.7199 14.91 22.7799C13.32 21.7199 10.69 21.7199 9.08997 22.7799Z",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthIcon);
export default __webpack_public_path__ + "static/media/strength-icon.f2b6a0a52908f120a0891abe67fd0142.svg";
export { ForwardRef as ReactComponent };